import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { finalize, lastValueFrom } from 'rxjs';

import { GrupoEmpresa } from '../../../../models/GrupoEmpresa';
import { EmpresasService } from '../../../../services/empresa/empresas.service';

@Component({
  selector: 'app-selecionar-grupo.component',
  imports: [
    MatProgressSpinnerModule,
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckbox,
  ],
  templateUrl: './selecionar-grupo.component.html',
  styleUrl: './selecionar-grupo.component.scss',
})
export class SelecionarGrupoComponent implements OnInit {
  public isLoading = false;
  listaDeGruposOriginal: any[] = [];
  listaDeGrupos: any[] = [];

  checkboxIndeterminate = true;
  checkboxChecked = false;

  constructor(
    public empresaService: EmpresasService,
    public dialogRef: MatDialogRef<SelecionarGrupoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  async ngOnInit(): Promise<void> {
    this.listaDeGruposOriginal = this.data.grupos.map((g: any) => ({
      ...g,
      selecionado: g.selecionado || false,
      buscaUsuarios: g.buscaUsuarios || false,
      buscaPessoas: g.buscaPessoas || false
    }));

    const selecionados = this.data.selecionados || [];

    this.listaDeGruposOriginal.forEach((g: any) => {
      const match = selecionados.find((s: any) => s.idGrupo === g.idGrupo);
      if (match) {
        g.selecionado = true;
        g.buscaUsuarios = !!match.buscaUsuarios;
        g.buscaPessoas = !!match.buscaPessoas;
      }
    });

    this.listaDeGrupos = [...this.listaDeGruposOriginal];
  }

  getCheckboxState(grupo: any): {
    checked: boolean;
    indeterminate: boolean;
  } {
    const { buscaUsuarios, buscaPessoas } = grupo;
    const checked = buscaUsuarios && buscaPessoas;
    const indeterminate = (buscaUsuarios || buscaPessoas) && !checked;

    return { checked, indeterminate };
  }

  updateFieldText(event: Event) {
    const query = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (!query) {
      this.listaDeGrupos = [...this.listaDeGruposOriginal];
      return;
    }

    this.listaDeGrupos = this.listaDeGruposOriginal.filter((grupo) =>
      grupo.nome.toLowerCase().includes(query)
    );
  }

  toggleGrupo(grupo: any, checked: boolean): void {
    grupo.buscaUsuarios = checked;
    grupo.buscaPessoas = checked;
    grupo.selecionado = checked;
  }

  onToggleFilho(grupo: any) {
    const { checked, indeterminate } = this.getCheckboxState(grupo);
    grupo.selecionado = checked || indeterminate;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    const selecionados = this.listaDeGruposOriginal.filter(g => g.selecionado);
    this.dialogRef.close(selecionados);
  }
}
